// Dynamically import @honeybadger-io/js so the ~5.6 MB SDK is split out of
// the initial chunk. Errors raised before the SDK finishes loading are
// queued and flushed once it's ready.

let honeybadger = null;
let loading = null;
const queue = [];

function load() {
  if (loading) return loading;

  loading = import('@honeybadger-io/js').then(({ default: Honeybadger }) => {
    Honeybadger.configure({
      apiKey: process.env.HONEYBADGER_API_KEY,
      environment: process.env.RAILS_ENV || process.env.NODE_ENV,
      revision: process.env.HEROKU_SLUG_COMMIT,
    });
    honeybadger = Honeybadger;

    queue.forEach(({ err, context }) => Honeybadger.notify(err, { context }));
    queue.length = 0;

    return Honeybadger;
  }).catch((loadErr) => {
    // Don't break the host app if the chunk fails to fetch.
    // eslint-disable-next-line no-console
    console.error('Failed to load Honeybadger SDK:', loadErr);
  });

  return loading;
}

function notify(err, context = {}) {
  if (honeybadger) {
    honeybadger.notify(err, { context });
  } else {
    queue.push({ err, context });
    load();
  }
}

window.HoneyBadger = {
  report() {},
  // report(payload) {
  //   if (payload instanceof Error) {
  //     notify(payload);
  //     return;
  //   }
  //   const { err, ...context } = payload || {};
  //   notify(err || 'Manual HoneyBadger.report', context);
  // },
};

// Catch uncaught errors during the SDK-loading window. Once the SDK is
// loaded, Honeybadger.configure() installs its own window.onerror handler;
// our listener becomes a no-op via the honeybadger guard.
window.addEventListener('error', (event) => {
  if (honeybadger) return;
  notify(event.error || new Error(event.message || 'window.onerror'), {
    source: 'window.onerror',
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
  });
});

window.addEventListener('unhandledrejection', (event) => {
  if (honeybadger) return;
  const reason = event.reason;
  const err = reason instanceof Error ? reason : new Error(String(reason));
  notify(err, { source: 'unhandledrejection' });
});

// Preload the SDK during idle time so it's ready for the common case
// without blocking initial render. Falls back to a short timeout where
// requestIdleCallback isn't supported.
if (typeof window.requestIdleCallback === 'function') {
  window.requestIdleCallback(load, { timeout: 2000 });
} else {
  setTimeout(load, 100);
}

export default window.HoneyBadger;
